import { Component, Input, OnDestroy, OnInit, ViewEncapsulation, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BehaviorSubject, Subscription, distinctUntilChanged } from 'rxjs';
import { GenerateRandom } from 'src/utils/random';

@Component({
  selector: 'app-upload-image',
  templateUrl: './upload-image.component.html',
  styleUrl: './upload-image.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => UploadImageComponent), multi: true
    }
  ],
  encapsulation: ViewEncapsulation.None,
})
export class UploadImageComponent implements OnInit, OnDestroy, ControlValueAccessor {
  imageUrl$ = new BehaviorSubject<string | ArrayBuffer | File | null>(null);

  @Input()
  set imageValue(data: string | File | null) {
    if (typeof data === 'string') {
      this.imageUrl$.next(data);
    } else if (data instanceof File) {
      const reader = new FileReader();
      reader.onload = () => this.imageUrl$.next(reader.result as string);
      reader.readAsDataURL(data);
    } else {
      this.imageUrl$.next(null);
    }
  }
  @Input() isDisabled = false;

  @Input() name = GenerateRandom(6);
  id = GenerateRandom(6);

  form = new FormControl();
  subscription: Subscription;

  onChange = (value: string) => { };
  onTouched = (value: string) => { };

  constructor() { }

  ngOnInit(): void {
    this.subscription = this.form.valueChanges.pipe(distinctUntilChanged()).subscribe((val) => {
      const value = this.form.value;
      this.onChange(value);
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  writeValue(value: any): void {
    this.form.setValue(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void { }

  processFile(imageInput: any) {
    const file: File = imageInput.files[0];

    const reader = new FileReader();
    this.form.setValue(file);

    reader.onload = (event) => {
      this.imageUrl$.next(reader.result);
    };

    reader.readAsDataURL(file);
  }

  onClick() {
    if (this.isDisabled) {
      return;
    }
    document.getElementById(`${this.id}`)?.click();
  }

  removeImage() {
    this.form.reset();
    this.imageUrl$.next(null);
  }
}
